import React from 'react'
import FICInputText from '../components-v2/FICInputText/FICInputText'
import FICRadioGroup from '../components-v2/FICRadioGroup/FICRadioGroup'
import FICCheckbox from '../components-v2/FICCheckbox/FICCheckbox'
import FICValidation from '../validation-v2/validation'
import FICAutocomplete from '../components-v2/FICAutocomplete/FICAutocomplete'
import FICSelect from '../components-v2/FICSelect/FICSelect'
import FICFileUploader from '../components/js/FICFileUploader'
import FICButton from '../components-v2/FICButton/FICButton'

/* eslint-disable react/prop-types */

const LargeInputText = ({ size, ...props }) => <FICInputText
  {...props}
  size='large'
/>

/* eslint-enable react/prop-types */

export const config = {
  components: {
    'text': {
      role: 'field',
      component: FICInputText
    },
    'text-large': {
      role: 'field',
      component: LargeInputText
    },
    'radio': {
      role: 'field',
      component: FICRadioGroup
    },
    'checkbox': {
      role: 'field',
      component: FICCheckbox
    },
    'autocomplete': {
      role: 'field',
      component: FICAutocomplete
    },
    'select': {
      role: 'field',
      component: FICSelect
    },
    'uploader': {
      role: 'field',
      component: FICFileUploader
    },
    'button': {
      role: 'field',
      component: FICButton
    }
  },
  customValidators: {
    itTaxCode: (value) => {
      if (!value) return ''
      return !FICValidation.itTaxCode(value) ? '^Codice fiscale non corretto' : ''
    },
    itVatNumber: (value) => {
      if (!value) return ''
      return !FICValidation.itVatNumber(value) ? '^Partita IVA non corretta' : ''
    },
    isEmail: (value) => {
      if (!value) return ''
      return !FICValidation.isEmail(value) ? '^Email non valida' : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/forms-v2/config.js